import { AccessGroupApiFacade } from "./access-group.api-facade";
import { AccessGroupStoreFacade } from "./access-group.store-facade";
import { VASRestService } from "../../../core/services/api/vas-rest";
import { VasStore } from "../../store/store-type";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { AccessGroup } from "./access-group.model";
import { CategoryFacade } from "../category/category.facade";
import { AccessGroupSchema } from "../../api/schema";
import { schema } from "normalizr";

export class AccessGroupFacade extends CategoryFacade<AccessGroup, AccessGroupApiFacade, AccessGroupStoreFacade> {


}



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.facade.ts